var map = {
	"./amarelle.jpg": 68,
	"./barbezat_fuchs.jpg": 69,
	"./borloz.jpg": 70,
	"./buclin.jpg": 71,
	"./buffat.jpg": 72,
	"./de_benedictis.jpg": 73,
	"./dittli.jpg": 74,
	"./gorrite.jpg": 75,
	"./keller.jpg": 76,
	"./luisier.jpg": 77,
	"./morand.jpg": 78,
	"./ruiz.jpg": 79,
	"./venizelos.jpg": 80
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;